import { createCaptureSnapshot } from './capture-snapshot'

/** Capture the state at the click, before lazy loading or opening the dialog. */
export async function captureVisiblePortal(): Promise<HTMLCanvasElement> {
  const target = document.body
  const width = window.innerWidth
  const height = window.innerHeight
  const snapshot = createCaptureSnapshot(target)
  try {
    const { toCanvas } = await import('html-to-image')
    return await toCanvas(snapshot, {
      width,
      height,
      pixelRatio: Math.min(window.devicePixelRatio || 1, 2),
      // Keep the displayed image variant, including its query parameters.
      includeQueryParams: true,
      style: { opacity: '1' },
    })
  } finally {
    snapshot.remove()
  }
}
